







import { Component, Vue, InjectReactive, Watch } from 'vue-property-decorator'
import App from "../App.vue"
import RestClient from "../components/RestClient.vue"

@Component
export default class MyComponent extends Vue {
    $log: any
    $t: any
    $parent!: App
    @InjectReactive() restClient!: RestClient
    mounted() {
        let q = this.$route.query
        if (q.error) {
            var message = String(q.error)
            if (q.error_description) {
                message = String(q.error_description)
            }
            this.$parent.onError(this.$t('auth_error'), message)
        } else {
            let auth = this.$route.params.auth
            this.$parent.getAccount(auth, {session: q.state, code: q.code})
        }
    }
}
